module.exports = __webpack_public_path__ + "img/ts.aed2483c.svg";